<template>
  <el-dialog
    class="set-month-metrix-modal"
    width="80%"
    :title="`${month}销售目标设置`"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="config-table">
      <el-table
        :data="context"
        ref="metrixTable"
        row-key="metrix"
        highlight-current-row
        max-height="520px"
        border
        header-row-class-name="metrix-setter-header"
      >
        <el-table-column label="#" fixed="left" width="50px" align="center">
          <template slot-scope="scope">
            <el-button type="text" style="padding: 0" @click="removeMetrix(scope.$index)"><i class="el-icon-remove-outline"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="metrix" property="metrix" fixed="left" label="指标" min-width="130px">
          <template slot-scope="scope">
            <el-select id="sel_${scope.$index}" v-model="scope.row.metrix" size="mini" placeholder="请选择考核指标项" @change="setMetrixName(scope.row)">
              <el-option
                v-for="metrix in metrixs"
                :key="metrix.name"
                :value="metrix.name"
                :label="metrix.showName"
                :disabled="optionDisabled(metrix, scope.$index)"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column v-for="(area, adix) in areas" :key="area" :label="area" min-width="130px">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              :class="{ wan: !((scope.row.metrix || '').endsWith('Count')) || scope.row.metrix === 'epcAmountCount'}"
              v-model="scope.row[area]"
              :min="0"
              :step="1"
              :id="`ipt_${scope.$index}_${adix}`"
              :disabled="!scope.row.metrix"
              :step-strictly="true"
              :precision="0"
              :controls="false"
              :placeholder="`请输入${area}目标${scope.row.metrixName}`"
            />
            <span v-if="!((scope.row.metrix || '').endsWith('Count'))">万</span>
            <span v-else-if="scope.row.metrix === 'epcAmountCount'">元</span>
          </template>
        </el-table-column>
        <el-table-column label="合计" fixed="right" min-width="130px" class-name="total-col">
          <template slot-scope="scope">
            <span>{{ calcTotal(scope.row) }}</span>
            <span v-if="!((scope.row.metrix || '').endsWith('Count'))">万</span>
            <span v-else-if="scope.row.metrix === 'epcAmountCount'">元</span>
          </template>
        </el-table-column>
        <template slot="append">
          <div class="add-row">
            <el-button size="mini" @click="copyMetrix" type="warning" v-if="context.length === 0">复制上月</el-button>
            <el-button size="mini" @click="addMetrix" type="primary">新增考核项</el-button>
          </div>
        </template>
      </el-table>
    </div>
    <div class="actions">
      <el-button size="small" @click="close(false)">取消</el-button>
      <el-button type="primary" size="small" @click="doSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import _ from 'lodash'
import { listMetrix, setMonthMetrix, copyLastMonthMetrix } from '../services'
import Sortable from 'sortablejs'
export default {
  name: 'SetMonthTaskModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      context: [],
      metrixs: [],
      month: undefined,
      draggedIndex: undefined
    }
  },
  computed: {
    areas () {
      return this.$store.state.stAreas
    }
  },
  methods: {
    init (existedData, month) {
      this.loadMetrixs()
      this.month = month
      this.convertData(existedData)
      const promise = this.open()
      this.$nextTick(() => {
        this.rowDrop()
      })
      return promise
    },
    rowDrop () {
      const tbody = document.querySelector('.set-month-metrix-modal .el-table__body-wrapper tbody')
      const fixedLeftBody = document.querySelector('.set-month-metrix-modal .el-table__fixed .el-table__fixed-body-wrapper tbody')
      const fixedRightBody = document.querySelector('.set-month-metrix-modal .el-table__fixed-right .el-table__fixed-body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.context.splice(oldIndex, 1)[0]
          _this.context.splice(newIndex, 0, currRow)
          _this.$nextTick(() => {
            _this.$refs.metrixTable.doLayout()
          })
        }
      })
      Sortable.create(fixedLeftBody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.context.splice(oldIndex, 1)[0]
          _this.context.splice(newIndex, 0, currRow)
          _this.$nextTick(() => {
            _this.$refs.metrixTable.doLayout()
          })
        }
      })
      Sortable.create(fixedRightBody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.context.splice(oldIndex, 1)[0]
          _this.context.splice(newIndex, 0, currRow)
          _this.$nextTick(() => {
            _this.$refs.metrixTable.doLayout()
          })
        }
      })
    },
    convertData (existedData) {
      if (existedData.length) {
        const grp = _.groupBy(existedData, t => t.metrix)
        const metrixs = []
        existedData.forEach((metrixRow) => {
          if (metrixs.indexOf(metrixRow.metrix) === -1) {
            metrixs.push(metrixRow.metrix)
          }
        })
        const context = []
        for (var key of metrixs) {
          const metrixRow = {
            metrix: key,
            mertixName: grp[key][0].mertixName
          }
          grp[key].forEach(areaMetrix => {
            if (areaMetrix.metrix.endsWith('Count')) {
              metrixRow[areaMetrix.area] = areaMetrix.metrixTarget
            } else {
              metrixRow[areaMetrix.area] = areaMetrix.metrixTarget / 10000
            }
          })
          context.push(metrixRow)
        }
        this.context = context
      }
    },
    getRowIndex (rowElement) {
      // Element UI adds a data-row-key or we can map it via the tbody children
      // A reliable way is to check the row's position in the table body
      const tbody = rowElement.closest('tbody')
      if (!tbody) return -1
      // Note: If you have fixed columns, Element creates duplicate tables.
      // You must ensure you are targeting the main table body.
      return Array.from(tbody.children).indexOf(rowElement)
    },
    dragStart (event) {
      const row = event.target.closest('tr')
      if (!row) return
      const rowIndex = this.getRowIndex(row)
      if (rowIndex === -1) return
      event.dataTransfer.effectAllowed = 'move'
      this.draggedIndex = rowIndex
    },
    drop (event) {
      event.preventDefault()
      const row = event.target.closest('tr')
      if (!row || this.draggedIndex === null) return
      const draggedRow = this.context[this.draggedIndex]
      // Remove the dragged person from the original position
      this.context.splice(this.draggedIndex, 1)
      // Insert it at the new position
      const newIndex = this.getRowIndex(row)
      this.context.splice(newIndex, 0, draggedRow)
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        if (this.context.some(t => !t.metrix)) {
          reject(new Error('考核项不能为空'))
          return
        }
        const emptyMetrix = this.areas.find(area => this.context[area] === 0)
        if (emptyMetrix) {
          reject(new Error(`${emptyMetrix.area}${emptyMetrix.metrixName}未设置`))
          // auto focus error input
          let aIdx = this.areas.indexOf(emptyMetrix.area)
          let rIdx = this.context.findIndex(t => t.metrix === emptyMetrix.metrix)
          document.querySelector(`#ipt_${rIdx}_${aIdx} input`) && document.querySelector(`#ipt_${rIdx}_${aIdx} input`).focus()
          return
        }
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel().then(() => {
        const postData = []
        this.context.forEach((metrixRow, index) => {
          this.areas.forEach(area => {
            postData.push({
              metrix: metrixRow.metrix,
              area,
              metrixTarget: metrixRow.metrix.endsWith('Count') ? metrixRow[area] : metrixRow[area] * 10000,
              month: this.month,
              sort: index
            })
          })
        })
        this.loading = true
        setMonthMetrix(postData, this.month).then((resp) => {
          this.$message.success('设置成功')
          this.close(true)
        }).finally(() => {
          this.loading = false
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    loadMetrixs () {
      this.loading = true
      listMetrix().then((resp) => {
        this.metrixs = resp
      }).finally(() => {
        this.loading = false
      })
    },
    optionDisabled (metrix, index) {
      return this.context.filter((_, idx) => idx !== index).map(t => t.metrix).indexOf(metrix.name) > -1
    },
    removeMetrix (index) {
      let needConfirm = false
      for (var prop in this.context[index]) {
        if (prop !== 'metrix' && prop !== 'metrixName') {
          if (this.context[index][prop] > 0) {
            needConfirm = true
            break
          }
        }
      }
      if (needConfirm) {
        this.$confirm('已有设置指标确认删除？', '确认').then(() => {
          this.context.splice(index, 1)
        })
      } else {
        this.context.splice(index, 1)
      }
    },
    calcTotal (metrixRow) {
      let total = 0
      this.areas.forEach(area => {
        total += metrixRow[area]
      })
      return total
    },
    addMetrix () {
      const metrixRow = {
        metrix: undefined
      }
      this.areas.forEach(area => {
        metrixRow[area] = 0
      })
      this.context.push(metrixRow)
    },
    setMetrixName (metrixRow) {
      if (metrixRow.metrix) {
        metrixRow.metrixName = this.metrixs.find(t => t.name === metrixRow.metrix).showName
      }
    },
    copyMetrix () {
      this.loading = true
      copyLastMonthMetrix(this.month).then(resp => {
        this.convertData(resp)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.set-month-metrix-modal
  min-width: 1024px
  .el-dialog
    .el-dialog__body
      padding-top 6px
      padding-bottom 20px
      overflow hidden
    .actions
      margin-top 12px
      text-align right
      .el-button
        width 100px
    .title
      font-size 16px
      font-weight bold
    .el-table
      tr
        user-select none
      .total-col
        bakcground #fff
      .metrix-setter-header
        th
          background #f2f2f2
      .current-row
        td
          background rgba(0,135,231,0.05)
          border-bottom-color #0279dc
          border-top-color #409eff
          border-top-style: solid
          border-top-width 1px
        &:not(.add-row)
          &:hover
            cursor move
      td
        .el-input-number--mini
          width 100px
          &.wan
            width 80px
            +span
              margin-left 4px
        .el-button--text
          margin-right 4px
        .el-select--mini
          width 100px
    .el-table__append-wrapper
      .add-row
        text-align center
        padding 10px 10px
</style>
